import React from 'react';
import { Box, Center, Spinner } from '@chakra-ui/react';
import { InboxPageWrapper } from '../../atoms/InboxPageWrapper';
import { InboxDetailsHeader } from '../../molecules/InboxDetailsHeader';
import { InboxMessage } from '../../molecules/InboxMessage';
import { useInboxDetailsContext } from 'src/features/Inbox/contexts/InboxDetailsContext';
import { ErrorNotifBox } from 'src/components/atoms/ErrorNotifBox';

export const InboxDetails: React.FC = () => {
  const { message, isLoading, isError } = useInboxDetailsContext();

  // TODO: will have to add a goal card here.

  if (isLoading) {
    return (
      <Center w="100%" h="100%">
        <Spinner speed="0.8s" size="xl" thickness="4px" />
      </Center>
    );
  }
  if (isError) {
    return (
      <Center w="100%" h="100%">
        <ErrorNotifBox
          title="Error loading inbox details!"
          description="There was an error loading the inbox details."
        />
      </Center>
    );
  }
  if (!message) {
    return (
      <Center w="100%" h="100%">
        <ErrorNotifBox
          title="No message found!"
          description="There is no message to display."
        />
      </Center>
    );
  }
  return (
    <InboxPageWrapper pageTitle="Inbox">
      <Box
        borderRadius={16}
        border="1px"
        borderColor="icon.green"
        p={6}
        gap={6}
        display="flex"
        flexDirection="column">
        <InboxDetailsHeader message={message} />
        <InboxMessage message={message} />
      </Box>
    </InboxPageWrapper>
  );
};
